import React from "react";
import "../Styles/Disclaimer.css";

const Disclaimer = () => {
  return (
    <>
        <div className="team-banner">
            <img src="/corporate/disclaimer.png" alt="" />
        </div>
   
    <div className="disclaimer-page">
      <div className="disclaimer-container">

       

        <h5 className="company-name">Swastika Infra Limited</h5>

        <h1 className="page-title">Disclaimer</h1>
        <div className="title-underline"></div>

        <p className="intro-text">
          If you require any more information or have any questions about our site's disclaimer,
          please feel free to contact us by email.
        </p>

        <h3>Disclaimers</h3>
        <p>
          All the information on this website is published in good faith and for general
          information purpose only. We do not make any warranties about the completeness,
          reliability and accuracy of this information.
        </p>

        <p>
          Any action you take upon the information you find on this website is strictly
          at your own risk. We will not be liable for any losses and/or damages in
          connection with the use of our website.
        </p>

        <p>
          From our website, you can visit other websites by following hyperlinks.
          While we try to provide only quality links, we have no control over the
          content of these external sites.
        </p>

        <p>
          Please also check the Privacy Policy and Terms of Service of other
          websites before engaging in any business.
        </p>

        <p>
          The images and graphical content used on this website are for illustrative
          purposes only and may not represent actual projects.
        </p>

        <p>
          All trademarks and logos belong to their respective owners.
        </p>

        <h3>Consent</h3>
        <p>
          By using our website, you hereby consent to our disclaimer and agree to its terms.
        </p>

        <h3>Update</h3>
        <p>
          We may update this document from time to time. Any changes will be posted here.
        </p>

      </div>
    </div>
     </>
  );
};

export default Disclaimer;
